/**
 * Enterprise Plan Tier Types
 * Enums for mapping downgrade/upgrade subscriptions and identifying tier plan type.
 * Please preserve the position of enums as this is important for identifying plan hierarchy.
 * @author Peter John Alvarado <peterjohn@gorated.ph>
 */
export var TierType;
(function (TierType) {
    TierType["FreeStarter"] = "free_starter";
    TierType["ProStarter"] = "pro_starter";
    TierType["ProBronze"] = "pro_bronze";
    TierType["ProSilver"] = "pro_silver";
    TierType["ProGold"] = "pro_gold";
    TierType["ProPlatinum"] = "pro_platinum";
    TierType["ProDiamond"] = "pro_diamond";
    TierType["ProMythical"] = "pro_mythical";
    // Always define legacy tier types at the bottom
    TierType["Free"] = "free";
    TierType["Enterprise"] = "enterprise";
    // Use for identifying plan tier type
    TierType["FreeTier"] = "free_tier";
    TierType["ProTier"] = "pro_tier";
})(TierType || (TierType = {}));
